import Vue from 'vue'
import moment from 'moment'

export const toCurency = Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'RON',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

export const formatPrice = Vue.filter('formatPrice', function (value) {
    let val = (value/1).toFixed(2);//.replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
});

export const formatInt = Vue.filter('formatInt', function (value) {
    return Math.trunc( value ) ;
});

export const formatDate = Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
    }
});